import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { HEADER_HEIGHT } from './constants';

import { ButtonLink } from '../Button';

const StyledHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: HEADER_HEIGHT,
  padding: '1.8rem 1.6rem 2.4rem 1.6rem',
}));

const StyledHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.8rem',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.main,
  textTransform: 'uppercase',
}));

const CUNotificationsHeaderComponent = ({ markAllAsViewed }) => (
  <StyledHeaderContainer>
    <StyledHeaderTitle>notifications</StyledHeaderTitle>
    <ButtonLink
      onClick={markAllAsViewed}
      sx={(theme) => ({
        fontSize: '1.5rem',
        color: theme.palette.custom.link,
      })}
    >
      Mark all as read
    </ButtonLink>
  </StyledHeaderContainer>
);

CUNotificationsHeaderComponent.propTypes = {
  markAllAsViewed: PropTypes.func.isRequired,
};

export default CUNotificationsHeaderComponent;
